import React from 'react'
import './TeacherBanner.css'
import { useNavigate } from 'react-router-dom';

function TeacherBanner() {

const navigate = useNavigate();

const handleGetStartedClick = () => {
    navigate("/signup");
    };

  return (
    <div className='teacherBanner-container'>
        <div className='teacherBanner-title'>
            <span className='title-banner'>Your Knowledge, Their Future.Start Teaching Today!</span>
            <span className='sub-title-banner'>Create courses, connect with students, and make a difference.</span>
            <div className='call-to-action'>
          <span className="start-user" onClick={handleGetStartedClick}>Get Started</span>
        </div>
        </div>
    </div>
  )
}

export default TeacherBanner